import script from "./SessionSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./SessionSearch.vue?vue&type=script&lang=ts&setup=true"

import "./SessionSearch.vue?vue&type=style&index=0&id=338d387b&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-338d387b"]])

export default __exports__